export const formatDate = (date) => {
	const dd = String(date.getDate()).padStart(2, '0');
	const mm = String(date.getMonth() + 1).padStart(2, '0');
	const yyyy = date.getFullYear();
	return `${yyyy}-${mm}-${dd}`;
};

export const generatePayload = ({
	updatedTab,
	activeTab,
	pageCount,
	pageSize,
	quickDateFrom,
	quickDateTo,
	search,
	filterValue,
	filterColumnName,
	sortingType,
	sortingName
}) => {
	const currentDate = new Date();
	const threeMonthsAgo = new Date();
	threeMonthsAgo.setMonth(currentDate.getMonth() - 3);

	const selectedTab = updatedTab?.[activeTab];
	const hasNonEmptySubtabs = selectedTab?.subTabs?.length > 0;

	return {
		page: pageCount || 1,
		limit: pageSize || 100,
		sortingType: sortingType || '',
		quickDateFrom:
			quickDateFrom || (hasNonEmptySubtabs ? formatDate(threeMonthsAgo) : null),
		quickDateTo:
			quickDateTo || (hasNonEmptySubtabs ? formatDate(currentDate) : null),
		search: search || null,
		filterValue: filterValue || null,
		filterColumnName: filterColumnName || null,
		sortingColumnName: sortingName || null
	};
};

export const handleDropdownChangeLogic = ({
	selectedValue,
	setStartDate,
	setEndDate,
	setOpenDatePicker,
	fetchDataWithMonthsChange,
	tabValue1,
	tabValue2,
	setSelectedQuickDate,
	pageCount,
	pageSize,
	filterValue,
	filterColumnName,
	sortingType
}) => {
	if (selectedValue !== 100) {
		setStartDate(null);
		setEndDate(null);
		const today = new Date();
		const previousDate = new Date(today);
		previousDate.setDate(today.getDate() - selectedValue);
		const quickDateFrom = formatDate(previousDate);
		const quickDateTo = formatDate(today);

		setSelectedQuickDate({ quickDateFrom, quickDateTo });
		const payload = generatePayload({
			updatedTab: null,
			activeTab: null,
			pageCount,
			pageSize,
			quickDateFrom,
			quickDateTo,
			search: null,
			filterValue,
			filterColumnName,
			sortingType: sortingType.sortingType,
			sortingName: sortingType.sortingName
		});

		fetchDataWithMonthsChange(tabValue1, tabValue2, payload);
	} else if (selectedValue === 100) {
		setOpenDatePicker(true);
		setSelectedQuickDate({ quickDateFrom: null, quickDateTo: null });
	}
};
